/* eslint-disable no-dupe-keys */
const ROUTE_CONSTANT = {
  LANDING: "/",
  HOME: "/home",
  CONTACT: "/contact",
  ATSMODULE: "/atsmodule",
  EMPLOYEEMODULE: "/employeemodule",
  ENGAGE: "/engage",
  PROJECTMODULE: "/projectmodule",
  ASSETSMODULE: "/assetsmodule",
  PROSPECTSMODULE: "/prospectsmodule",
  REPORTSMODULE: "/reportsmodule",
  DEMO: "/bookDemo",
  CREATE_JOB: "/job/create",
  UPDATE_JOB: "/job/update/:jobId",
  VIEW_SPECIFIC_JOB: "/job/view/:jobId",
  VIEW_JOBS: "/job/view",
  JOB_WISE: "/reports/job",
  CLIENT_WISE: "/reports/client",
  RECRUITER_WISE: "/reports/RecruiterWise",
  CREATE_APPLICANT: "/applicant/create",
  VIEW_APPLICANT: "/applicant/view",
  APPLICANT: "/applicant",
  CREATE_PLACEMENT: "/placement/create",
  VIEW_PLACEMENT: "/placement/view",
  PLACEMENT: "/placement",
  PLACEMENT_SPECIFIC_DETAILS: "/placement/view/:Id",
  ASSET_TABS: "/assets/view",
  CREATE_ASSET: "/assets/create",
  VIEW_ASSET: "/assets/viewasset",
  ALLOCATED_ASSET: "/assets/allocateasset",
  ASSET_SPECIFIC_DETAILS: "/asset/view/:Id",
  INVOICE: "/invoice",
  VIEW_INVOICE: "/invoice/view",
  INVOICE_SPECIFIC_DETAILS: "/invoice/view/:Id",
  CREATE_CLIENT: "/client/create",
  VIEW_CLIENT: "/client/view",
  CLIENT_SPECIFIC_DETAILS: "/client/view/:Id",
  ORGANIZATION_VIEW_SPECIFIC: "/organization/view/:orgId",
  CREATE_VENDOR: "/vendor/create",
  VIEW_VENDOR: "/vendor/view",
  VENDOR_SPECIFIC_DETAILS: "/vendor/view/:Id",
  INVOICE: "/invoice",
  MY_DETAILS: "/mydetails",
  APPLICANT_SPECIFIC_DETAILS: "/applicant/view/specific",
  ATTENDENCE_REPORT: "/reports/attendance",
  LOGIN: "/login",
  NOT_AUTHORIZED: "/notauthorized",
  BANK_ACCOUNT: "/bankaccount",
  PAY_SLIPS: "/payslips",
  TAX_FORM: "/taxform",
  ONBOARD_ORGANIZATION: "/org/onboard",
  CLAIM_TABS: "/claimtabs",
  CLAIM: "/claim",
  MEDICAL_CLAIM: "/medicalclaim",
  INTERVIEW_SCHEDULE: "/interview/schedule",
  SCHEDULED_INTERVIEWS: "/scheduledInterviews",
  VIEW_SCHEDULE: "/schedule/view",
  SCHEDULE_DETAILS_PAGE: "/scheduledetails/:Id",
  MY_PROFILE: "/profile",
  VIEW_EMPLOYEE: "/employee/view",
  BLANK_BOARD: "/blackboard",
  CREATE_PAYROLL: "/payroll/create",
  VIEW_PAYROLL: "/payroll/view",
  ATTENDENCE_REPORT: "/attendencereport",
  CREATE_USER: "/organization/createuser",
  // PAST_PAYRUNS: "/pastpayruns",
  PASTPAYRUNS: "/pastpayruns",
  PAYROLL_REPORTS: "/payrollReports",
  THANK_YOU: "/thankyou",
  VIEW_USER: "/org/viewuser",
  EDIT_USER: "/org/edituser/view",
  REPORTSBYATTENDENCE: "/reports/attendencereport",
  REPORTSBYJOB: "/reports/job",
  RESIGNATION_REPORT: "/resignationReport/resignationreport",
  BUDGET_REPORT: "/budgetReport",
  COMPENSATION_REPORT: "/compensationTab",
  JOB_SPECIFIC_DETAILS: "/jobIdSpecificDetails",
  EMPLOYEE_SPECIFIC_DETAILS: "/employeeSpecificDetails",
  // APPLICANT_SPECIFIC_DETAILS: "/applicantSpecificDetails",
  CLIENT_SPECIFIC_DETAILS: "/client/view/:Id",
  RECRUITER_SPECIFIC_DETAILS: "/recruiterSpecificDetails",
  VIEW_CARD: "/viewcard",
  PLACEMENT_ID: "/placement/Id",
  CREATE_PROJECT: "/organization/CreateProject",
  VIEW_ORGANIZATION: "/organization/ViewOrganization",
  PROJECT_DETAILS: "/organization/ViewProject",
  EDIT_PROJECT: "/organization/EditProject/:Id",
  ASSIGNED_TASK: "/assignedTask/:Id",
  UPDATE_TASK: "/updateTask/:Id",
  ORGANIZATION: "/organization",
  CREATE_SUB_VENDOR: "/SubVendor",
  VIEW_SUB_VENDOR: "/ViewSubVendor",
  HOME_ADMIN: "/homeadmin",
  CREATE_BOARD: "/CreateBoard",
  BOARD: "/board/:Id",
  PORTAL_ROLE: "/organization/portalRole",
  VIEW_POTAL_ROLE: "/org/viewportalrole",
  PORTAL_ROLE_TAB: "/PortalRoleTab",
  NOTIFICATION: "/notification",
  ORGANIZATION_CHART: "/TeamStructure",
  MY_TEAM: "/MyTeam",
  CREATE_NOTIFICATION: "/createNotification",
  SUB_VENDOR_SPECIFIC_DETAILS: "/SubVendor/view/:subvendorId",
  MYTIME: "/MyTime",
  APPRECIATION: "/Appreciation",
  VIEW_APPRECIATION: "/ViewAppreciation",
  APPRECIATION_TABS: "/AppreciationTabs",
  CREATE_HOLIDAY: "/CreateHoliday",
  VIEW_PROJECT_DETAILS: "/organization/ProjectDetails/:projectId",
  APPLY_FOR_LEAVE: "/MYTime/ApplyForLeave",
  HOLIDAY_CALENDAR: "/MYTime/HolidayCalendar",
  NEW_JOINERS: "/NewJoiners",
  PRIVACY_POLICY: "/PrivacyPolicy",
  SECURITY_POLICY: "/SecurityPolicy",
  TERMS_OF_SERVICE: "/TermsofService",
  PRICING: "/Pricing",
  COOKIE_POLICY: "/CookiePolicy",
  OUR_SERVICES: "/OurServices",
  VIEW_CLAIM: "/ViewClaim",
  VIEW_PROJECT: "/ViewProject",
  POLICY_TAB: "/PolicyTab",
  EDIT_POLICY: "/EditPolicy/:Id",
  VIEW_POLICY_TEMPLATE: "/policyTemplate/:Id",
  TEMPLATE: "/Template",
  EDIT_TEMPLATE: "/EditTemplate/:Id",
  HIRERACHY: "/Hierarchy",
  VIEW_HIERARCHY: "/ViewHierarchy",
  HIERARCHY_TABS: "/viewhierarchy",
  UPDATE_HIERACHY: "/UpdateHierachy/view/:level",
  HR_LETTER_TAB: "/HRLetterTab",
  VIEW_HR_LETTER_TAB: "/HRLetterTab/view",
  CREATE_OFFER_LETTER: "/CreateOfferLetter",
  VIEW_OFFER_LETTER: "/ViewOfferLetter",
  CREATE_POLICY: "/CreatePolicy",
  VIEW_POLICY: "/ViewPolicy",
  VIEW_TEMPLATE: "/ViewTemplate",
  TEMPLATE_TAB: "/TemplateTab",
  PAYROLL_SCHEDULE: "/payRollSchedule",
  TIME_SHEET: "/timesheet",
  TIME_SHEET2: "/timesheet2",
  EDIT_APPROVED_LEAVE: "/editApprovalLeave/:Id",
  EDIT_LEAVE: "/editLeave/:Id",
  APPLICANT_LOGIN: "/preOnboarding",
  APPLICANT_JOB: "/viewJob",
  GRATUITY: "/gratuity",
  VIEW_GRATUITY: "/ViewGratuity",
  GRATUITY_TABS: "/GratuityTabs",
  UPDATE_GRATUITY: "/UpdateGratuity/view/:employeeId",
  F_AND_F: "/f&fSettlement",
  SETTLEMENT_TABS: "/Settlement",
  UPDATE_SETTLEMENT: "/UpdateSettlement/view/:userId",
  SURVEY: "/Survey",
  SURVEY_TAB: "/SurveyTab",
  PERFORMANCE_TAB: "/PerformanceTab",
  VIEW_SURVEY: "/ViewSurvey",
  SURVEY_DETAILS: "/SurveyDetails/view/:Id",
  ASSESSMENT_DETAILS: "/assessmentDetails/view/:Id",
  EMPLOYEE_SURVEY_DETAILS: "/EmployeeSurveyDetails/view",
  EMPLOYEE_SURVEY_PUBLIC_DETAILS: "/PublicSurveyDetails/view/:Id",
  EMPLOYEE_ASSESSMENT_PUBLIC_DETAILS: "/PublicAssessmentDetails/view/:Id",
  UPLOAD_DOCUMNETS: "/UploadDocuments",
  UPLOAD_VERICIATION: "/UploadVerification/:applicantId",
  // VIEW_SETTLEMENT: "/ViewSettlement",
  EDITTAX: "/EditTax",
  APPROVE: "/ApproveTabs",
  APPRAISAL: "/appraisal",
  TASKTYPE: "/Tasktype",
  VIEW_TASKTYPE: "/ViewTaskType",
  TASKTYPE_TABS: "/viewTaskType",
  UPDATE_TASKTYPEASSIGN: "/UpdateTaskTypeDetails/view/:Id",
  LEAVE_CONFIG: "/LeaveConfig",
  TIME_LINE: "/timeline",
  APPLICANT_DETAILS_PRE: "/ApplicantProfile",
  EMAIL: "/Email",
  EMAIL_CONFIG: "/EmailConfig",
  EDIT_EMAIL_CONFIG: "/EmailConfig/view/:Id",
  RESPONSE: "/response",
  APPROVAL_HIERACHY: "/ApprovalHierachy",
  VIEW_APPROVAL_HIERARCHY: "/ViewApprovalHierarchy",
  APPROVAL_HIERARCHY_SPECIFIC_DETAILS:
    "/ApprovalHierarchySpecificDetails/view/:Id",
  APPROVAL_DETAILS: "/ApprovalDetails",
  EXPERIENCE_LETTER: "/ExperienceLetter",
  POLICY_DETAILS: "/Policy/PolicyTab/PolicyCard",
  POLICIES_LIST: "/ListOfPolicies",
  APPROVAL_DETAILS_SPECIFIC_DETAILS: "/ApprovalDetailsSpecificDetails/view/:Id",
  COMPENSATION_SETUP: "/CompensationSetup",
  MAP_RFID: "/maprfid",
  DEPARTMENT_ROLES: "/DepartmentAndRoles",
  EDIT_DEPARTMENT_ROLES: "/EditDepartmentAndRoles",
  PASSWORD_QUESTIONS: "/PasswordQuestions",
  SCREEN_CONFIG: "/ScreenConfiguration",
  RESET_PASSWORD: "/ResetPassword",
  CREATE_PAYROLL_CONFIGURATION: "/createpayrollconfig",
  PAYROLL_CONFIGURATION: "/PayrollConfig/:Id",
  VIEW_PAYROLL_TEMPLETE: "/ViewPayrollConfig",
  SHIFT_CONFIGURATION: "/shiftConfiguration",
  ROASTER_CONFIG: "/roasterConfiguration",
  VIEW_ROASTER_CONFIG: "/viewRoasterConfig",
  EDIT_ROASTER_CONFIG: "/viewRoasterConfig/:shiftId",
  VIEW_ERRORS: "/ViewErrors",
  JOB_PUBLIC: "/jobview/:jobId",
  NOTIFICATION_TAB: "/NotificationTab",
  VIEW_NOTIFICATION: "/Notification/view",
  JOB_LOGIN: "/Joblogin",
  SCREENS: "/Screens",
  BAND: "/band",
  PAYROLL_CALCULATION: "/PayrollCalculation",
  EXPORT_TIME_SHEET: "/exportTimesheet",

  INVOICE_HEADER_CUSTOMIZER: "/invoiceHeadCustomizer",
  INVOICE_PRODUCT_QUOTATION: "/createInvoiceProductQuotation",
  INVOICE_PRODUCT_QUOTATION_TABS: "/invoiceProductQuotation",
  VIEW_INVOICE_QUOTATION: "/viewInvoiceQuotation",
  EDIT_INVOICE_QUOTATION: "/editInvoiceQuotation/:Id",

  TYPEOF_EMPLOYMENT: "/TypeOfEmployment",
  EDIT_TYPEOF_EMPLOYMENT: "/TypeOfEmployment/edit/:empId",
  OFFERLETTER_SPECIFIC_DETAILS: "/HRLetterTab/view/:Id",
  VIEW_PERFORMANCE: "/ViewPerformance",
  AUTHORIZED_SIGNATURES: "/AuthorizedSignatures",
  VIEW_AUTHORIZED_SIGNATURES: "/AuthorizedSignatures/view/:Id",
  EXPERIENCE_LETTER_SPECIFIC_DETAILS: "/HRLetterTab/Experienceview/:Id",
  HIKE_LETTER_SPECIFIC_DETAILS: "/HRLetterTab/Hikeview/:Id",
  HUMANWRK_INVOICE: "/HumanWrkInvoice",
  VIEW_HUMANWRK_INVOICE: "/HumanWrkInvoice/view",
  HUMANWRK_INVOICE_SPECIFIC_DETAILS: "/HumanWrkInvoice/view/:Id",
  VIEW_SURVEY: "/SurveyTab#viewSurvey",
  LOGS: "/logs",
  POLICIES_AGREEMENT: "/PoliciesAgreement",
  FINANCIAL: "/Financial",
  VIEW_BOOK_DEMO: "/ViewBookDemo",
  VIEW_ENQUIRES: "/ViewEnquiries",
  VIEW_COURSE_PUBLIC: "/courseview/:Id",
  CREATE_COURSE: "/CreateCourse",
  VIEW_COURSE: "/course/view",
  CREATE_STUDENT_APPLICANT: "/CreateStudentApplicant",
  VIEW_STUDENT_APPLICANTS: "/ViewStudentApplicants",
  COURSE_SPECIFIC_DETAILS: "/course/view/:Id",
  COURSE_LOGIN: "/courselogin",
  APPLICANT_STUDENT_LOGIN: "/student/preOnboarding",
  VIEW_STUDENT_COURSE: "/view/courses",
  UPDATE_COURSE: "/course/update/:courseId",

  STUDENT_APPLICANT_SPECIFIC_DETAILS: "/studentApplicant/view/specific",
  CREATE_STUDENT_APPLICANT: "/studentApplicant",
  COURSE_PAYMENT_OVERVIEW: "/course/paymentOverview",
  VIEW_COURSE_PAYMENT_OVERVIEW: "/course/view/paymentOverview/:Id",
  STUDENT_ONBOARDING: "/student/onboarding",
  VIEW_STUDENTS: "/view/students",
  VIEW_STUDENT: "/view/student",
  EDIT_STUDENT: "/editStudent/:Id",
  CREATE_CAMPAIGN: "/createCampaign",
  CREATE_CONTACT_MANAGEMENT: "/createContantManagement",
  VIEW_ALL_CONTACT_MANAGEMENT: "/ViewAllContactManagement",
  CRM_DASH_BOARD: "/CrmDashBoard",
  CREATE_CRM_FORM: "/createCrmForm",
  UPDATE_CRM_FORM: "/editCrmForm/:Id",
  CRM_TEAM_DASH_BOARD: "/CrmTeamDashBoard",
  SALES_REPORT: "/SalesReport",
  VIEW_APPLICANT_ONBOARDINGLIST: "/PreOnBoardingApplicantList",
  EDIT_CONTACT_MANAGEMENT: "/editContantManagement/:Id",
  CREATE_ORDER: "/createOrder",
  CREATE_INVENTORY_MANAGEMENT: "/CreateInventoryManagement",
  VIEW_INVENTORY_MANAGEMENT: "/ViewInventoryManagement",
  EDIT_INVENTORY_MANAGEMENT: "/editInventoryManagement/:itemId",
  INVENTORY_CONFIG: "/InventoryConfig",
  EDIT_INVENTORY_MRPTYPE: "/editInventoryMrpType/:id",
  EDIT_INVENTORY_PROCUREMENTTYPE: "/editInventoryProcurementType/:id",
  EDIT_INVENTORY_MATERIALTYPE: "/editInventoryMaterialType/:id",
  CREATE_SUPPLIER: "/createSupplier",
  VIEW_ALL_SUPPLIERS: "/ViewAllSuppliers",
  EDIT_SUPPLIER: "/editSupplier/:Id",
  CREATE_WAREHOUSE: "/createWarehouse",
  VIEW_WAREHOUSE: "/ViewWareHouse",
  PRODUCT_CATALOG: "/productCatalog",
  VIEW_PRODUCT_CATALOG: "/viewProductCatalog",
  STUDENT_DASHBOARD: "/mylearning",
  COURSES_OVERVIEW: "/explorecourses",
  COURSE_INFO: "/course/:courseId",
  PROJECT_QUOTATION: "/projectQuotation",
  VIEW_ORDERS: "/ViewOrders",
  EDIT_ORDER: "/editOrder/:orderId",
  EDIT_WAREHOUSE: "/editWarehouse/:warehouseId",
  CAREERS: "/Careers",
  TAX_INVOICE: "/taxInvoice",
  TAX_INVOICE_SPECIFIC_DETAILS: "/taInvoice/:Id",
  VIEW_TAX_INVOICE: "/viewTaxInvoice",
  CREATE_PRICE_LISTS: "/createPriceLists",
  ENABLE_INVENTORY_TRACKING: "/enableInventoryTracking",
  MANAGE_INVENTORY: "/manageInventory",
  ASSESSMENT: "/assessment",
  VIEW_SPECIFIC_EMPLOYEE_PERFORMANCE: "/viewSpecificEmployeePerformance/:Id",
  VIEW_ASSESSMENT: "/viewAssessment",
  EDIT_ASSESSMENT: "/editAssessment/:assessmentId",
  START_ASSESSMENT: "/startAssessment/:assessmentId",
  VIEW_RESPONSE: "/viewResponse",
  Batch: "/batch",
  PERFORMANCE_DETAILS: "/PerformanceDetails/view/:Id",
  RULES_AND_REGULATIONS: "/rulesAndRegulations/:assessmentId",
  BATCH_WISE_ASSESSMENT: "/batchWiseAssessment",
  VIEW_BATCH_WISE_ASSESSMENT: "/viewBatchWiseAssessment",
  EDIT_BATCH_WISE_ASSESSMENT: "/editBatchWiseAssessment/:Id",
  EDIT_PRODUCT_CATALOG: "/editProductCatalog/:productId",
  COURSE_PROGRESS: "/courseProgress",
  CREATE_QUOTATION: "/createQuotation",
  EDIT_PRODUCT_QUOTATION: "/editProductQuotation/:Id",
  VIEW_PRODUCT_QUOTATION: "/viewProductQuotation",
  VIEW_BATCH: "/viewBatch",
  EDIT_ASSESSMENT_BATCH: "/createBatch/:batchId",
  CREATE_BATCH: "/createBatch",
  ACCOUNT_CREATION: "/accountCreation",
  INTERVIEW_EVALUATION: "/interviewEvaluation",
  INTERVIEW_TEMPLATE_CREATION: "/interviewTemplateCreation",
  VIEW_INTERVIEW_TEMPLATES: "/viewInterviewTemplates",
  EDIT_INTERVIEW_TEMPLATE: "/editInterviewTemplate/:Id",
  INTERVIEW_PERFORMANCE: "/interviewPerformance",
  PROJECT_CONFIG: "/projectConfig",
  JOB_WISE_INTERVIEW_PERFORMANCE: "/jobWiseInterviewPerformance",
  EDIT_INTERVIEW_PERFORMANCE: "editInterviewPerformance/:Id",
  CLAIMS_ADMIN: "/claims",
  UPDATE_ADMINCLAIM: "/claims/update/:Id",
  UPDATE_CLAIM: "/claim/update/:Id",
  UPDATE_MEDICAL_CLAIM: "/medicalClaim/update/:Id",
  MY_INTERVIEWS: "/myInterviews",
  CASH_ON_HAND: "/cashOnHand",
  BILLS: "/bills",
  LEDGER_CREATION: "/ledgerCreation",
  ORG_KEYS: "/orgKeys",
  FACE_CAPTURE: "/faceCapture",
  CREATE_LEAD: "/createLead",
  EDIT_LEAD: "/editLead/:Id",
  SALES_TARGETS: "/salesTargets",
  SALES_PERFORMANCE_REPORTS: "/salesPerformanceReports",
  SALES_REPORTS: "/salesReport",
  LEADS: "/leads",
  FACE_DETECT: "/faceDetect",
  ASSESSMENT_TABS: "/assessmentTabs",
  VIEW_ASSESSMENT_RESULTS: "/viewAssessmentResults/:assessmentId",
  EMPLOYEE_LOCATION_MAP: "/employeeLocationMap",
  CREATE_WHATSAPP_TEMPLATE: "/createWhatsappTemplate",
  CATEGORIES: "/categories",
  BRANDS: "/brands",
  WARRANTIES: "/warranties",
  UNITS: "/units",
  VARIATIONS: "/variations",
  ADD_PURCHASE: "/addPurchase",
  LIST_PURCHASES: "/listPurchases",
  LIST_PURCHAE_RETURN: "/listPurchaseReturn",
  SELLING_PRICE_GROUPS: "/sellingPriceGroups",
  IMPORT_OPENING_STOCK: "/importOpeningStock",
  IMPORT_PRODUCTS: "/importProducts",
  ADD_SALES: "/addSells",
  EDIT_SALES: "/addSells/:Id",
  ALL_SALES: "/allSales",
  BUSINESS_LOCATION: "/businessLocation",
  ADD_PRODUCT: "/addProduct",
  EDIT_PRODUCT: "/addProduct/:Id",
  LIST_PRODUCTS: "/listProducts",
  ADD_OPENING_STOCK: "/addOpeningStock",
  PURCHASE_RETURN: "/purchases/add/returns",
  PURCHASES_EDIT_PURCHASE_RETURN: "/purchases/add/returns/:Id",
  EDIT_PURCHASE: "/purchases/add/:Id",
  LIST_SELL_RETURN: "/listSellReturn",
  ADD_LIST_SELL_RETURN: "/sell/add/returns",
  ADD_STOCK_TRANSFER: "/addStockTransfer",
  CUSTOMERS: "/customers",
  BIZWRKDASHBOARD: "/bizWrkDashboard",
  SUPPLIERS: "/suppliers",
  LIST_STOCK_TRANSFER: "/listStockTransfer",
  ADD_PRODUCT_OPENING_STOCK: "/addProductOpeningStock/:Id",
  WHATSAPP_ORG_KEYS: "/whatsappOrgKeys",
  VIEW_APPROVED_SALARY_ADVANCE: "/ViewSalaryAdvance/:Id",
  VIEW_APPROVED_RESIGNATION: "/ViewResignation/:Id",
  VIEW_APPROVED_ATTENDANCE: "/ViewAttendance/:Id",
  CREATE_BIZ_CONTACT: "/createBizContact",
  EDIT_BIZ_CONTACT: "/createBizContact/:Id",
  CREATE_VOUCHERS: "/createVouchers",
  CREATE_BANK_STATEMENT: "/createBankStatement",
  CREATE_TAX_CODES: "/createTaxCodes",
  VIEW_TAX_CODES: "/viewTaxCodes",
  EDIT_TAX_CODES: "/createTaxCodes/:Id",
  SUPPLIER_LEDGERS: "/supplierLedger/:Id",
  CREATE_BIZ_CONTACT: "/createBizContact",
  EDIT_BIZ_CONTACT: "/createBizContact/:Id",
  CREATE_FINGER_PRINT_REPORT: "/createFingerPrintReport",
  EDIT_FINGER_PRINT_REPORT: "/editFingerPrintReport/:Id",
  VIEW_FINGER_PRINT_REPORT: "/viewFingerPrintReport",
  CREATE_WASTE_MANAGEMENT_QUOTATION: "/createWasteManagementQuotation",
  VIEW_WASTE_MANAGEMENT_QUOTATION: "/viewWasteManagementQuotation",
  EDIT_WASTE_MANAGEMENT_QUOTATION: "/editWasteManagementQuotation/:Id",
  CREATE_MEMBERSHIP: "/createMembership",
  VIEW_MEMBERSHIP: "/viewMembership",
  EDIT_MEMBERSHIP: "/editMembership/:Id",
  EMPLOYEES_REPORTS: "/employeesReports",
  CREATE_VOUCHERS: "/createVouchers",
  CREATE_JOURNAL_ENTRIES: "/createjournalEntries",
  CUSTOMER_LEDGER: "/customers/ledger/:Id",
  PURCHASE_PRODUCT_REPORTS: "/productPurchaseReports",
  PURCHASE_AND_SALE: "/purchaseAndSale",
  CUSTOMER_AND_SUPPLIER_REPORTS: "/customerAndSupplierReports",
  EMPLOYEE_OVERTIME: "/employeeOvertime",
  FINANCIAL_REPORTS: "/financialReports",
  PURCHASE_SELL_REPORTS: "/productSellReports",
  EDIT_STOCK_TRANSFER: "/editStockTransfer/:Id",
  TICKET_DASHBOARD: "/ticketDashboard",
  TICKETS: "/tickets",
  PRODUCT_HISTORY: "/products/productHistory/:Id",
  TICKET_SPECIFIC_DETAILS: "/ticketSpecificDetails/:Id",
  SUPPORT_CONFIGURATION: "/supportConfiguration",
  ROUTE_MANAGEMENT: "/routeManagement",
  VEHICLE_MANAGEMENT: "/vehicleManagement",
  TRANSPORT_MANAGEMENT_DASHBOARD: "/transportManagementDashBoard",
  DRIVER_MANAGEMENT: "/driverManagement",
  VIEW_EMAILS: "/viewEmails",
  STUDENT_MAPPING: "/studentMapping",
  ATTENDANCE_TRACKER: "/attendanceTracker",
  VEHICLE_TRACKING: "/vehicleTracking",
  INWARD_INVOICE: "/inwardInvoice",
  VIEW_INWARDINVOICE: "/inwardInvoice/view",
  INWARD_INVOICE_DETAILS: "/inwardInvoice/view/:Id",
  BASE_LEADS: "/baseLeads",
  CREATE_CRM_BASE: "/createCrmBase",
  UPDATE_CRM_BASE: "/updateCrmBase/:Id",
  ESTIMATION: "/Estimation",
  VIEW_ESTIMATION: "/viewEstimation",
  VIEW_VENDOR_ESTIMATION_FORM: "/vendor-response/:vendorToken",
  VIEW_SPECIFIC_ESTIMATION_DETAILS: "/viewSpecifcEstimation/:estimationId",
  BOQ: "/Boq",
  CREATE_CRM_ENTRIES: "/createCrmEntries",
  EDIT_CRM_ENTRIES: "/editCrmEntries/:recordId",
  VIEW_CRM_ENTRIES: "/viewCrmFormEntries",
  VIEW_CRM_FORMS: "/viewCrmForms",
  VIEW_MANAGER_DASHBOARD: "/viewManagerDashboard",
  CREATE_SEVA_TYPE: "/createSevaType",
  EDIT_SEVA_TYPE: "/editSevaType/:Id",
  VIEW_SEVA_TYPES: "/viewSevaTypes",
  CREATE_TEMPLE_MASTER: "/createTempleMaster",
  EDIT_TEMPLE_MASTER: "/editTempleMaster/:Id",
  VIEW_TEMPLE_MASTERS: "/viewTempleMasters",
  SHEDULE_SEVA: "/scheduleSeva",
  EDIT_SCHEDULE_SEVA: "/editScheduleSeva/:Id",
  VIEW_SEVA_SCHEDULES: "/viewSevaSchedules",
  DONATION_TYPE: "/donationType",
  EDIT_DONATION_TYPE: "/editDonationType/:Id",
  VIEW_DONATION_TYPES: "/viewDonationTypes",
  CREATE_DEVOTEE: "/createDevotee",
  EDIT_DEVOTEE: "/editDevotee/:Id",
  VIEW_DEVOTEES: "/viewDevotees",
  DEVOTEE_OCCASION: "/devoteeOccasion",
  EDIT_DEVOTEE_OCCASION: "/editDevoteeOccasion/:Id",
  VIEW_DEVOTEE_OCCASIONS: "/viewDevoteeOccasions",
  CREATE_DONATIONS: "/createDonations",
  VIEW_DONATIONS: "/viewDonations",
  EDIT_DONATIONS: "/editDonations/:Id",
  CREATE_DONATION_ITEMS: "/createDonationItems",
  VIEW_DONATION_ITEMS: "/viewDonationItem",
  EDIT_DONATION_ITEMS: "/editDonationItem/:Id",
  CREATE_POOJA_BOOKING: "/createPoojaBooking",
  VIEW_POOJA_BOOKING: "/viewPoojaBooking",
  EDIT_POOJA_BOOKING: "/editPoojaBooking/:Id",
  CREATE_RECEIPT_ATTACHMENT: "/createReceiptAttachment",
  VIEW_RECEIPT_ATTACHMENT: "/viewReceiptAttachment",
  EDIT_RECEIPT_ATTACHMENT: "/editReceiptAttachment/:Id",
  CREATE_VOUCHER: "/createVoucher",
  EDIT_VOUCHER: "/editVoucher/:Id",
  CREATE_POOJA_RECEIPT: "/createPoojaReceipt",
  EDIT_POOJA_RECEIPT: "/editPoojaReceipt/:Id",
  GET_ALL_RECEIPTS: "/viewAllReceipts",
  EDIT_RECEIPT: "/editPoojaReceipt/:Id",
  VIEW_VOCHERS: "/viewVochers",
  DAILY_RECEIPTS_BY_PAYMENT_MODE: "/dailyReceiptsByPaymentMode",
  DAILY_RECEIPT_BY_SEVA: "/dailyReceiptBySeva",
  DONOR_REPORT: "/donorReport",
  DAILY_RECEIPT: "/dailyReports",
  BALANCESHEET_REPORTS: "/balanceSheet",
  DEVOTEE_BY_SEVATYPE_REPORTS: "/DevoteesBySevaTypeReport",
  APPROVALS: "/approvals",
  SASWATA_ANNAPRSADA_EXCEL: "/saswataAnnPrsadaExcel"
};
export default ROUTE_CONSTANT;
